import networkCallWrapper from "../utils/networkCallWrapper";

const submitEddData = async () =>
  await networkCallWrapper({
    url: "v2/limits/edd/submit",
    method: "POST",
    service: "wallet"
  });

export default submitEddData;
